<template>
  <div>
    <!-- 箱规修改 -->
    <el-dialog :title="$t('message.boxGaugeModification')" :close-on-click-modal="false" :visible.sync="dialogVisible"
      width="725px" center>
      <div class="content">
        <div class="table">
          <ol>
            <!-- 箱型 -->
            <li class="flex15">
              {{ $t("message.boxPile") }}
            </li>
            <!-- 长 -->
            <li>
              {{ $t("message.length") }}
            </li>
            <!-- 箱宽型 -->
            <li>
              {{ $t("message.width") }}
            </li>
            <!-- 高 -->
            <li>
              {{ $t("message.height") }}
            </li>
            <!-- 重量 -->
            <li>
              {{ $t("message.weight") }}(kg)
            </li>
          </ol>
          <ul>
            <!-- 箱型 -->
            <li class="flex15">
              <el-select v-model="attr" placeholder="请选择" @change="setCWK">
                <el-option v-for="item in attrOption" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </li>
            <!-- 长 -->
            <li>
              <el-input v-model="c" oninput="value=value.replace(/^([0-9]\d*\.?\d{0,3})?.*$/,'$1')"
                onfocus="this.select()"></el-input>
            </li>
            <!-- 箱宽型 -->
            <li>
              <el-input v-model="k" oninput="value=value.replace(/^([0-9]\d*\.?\d{0,3})?.*$/,'$1')"
                onfocus="this.select()"></el-input>
            </li>
            <!-- 高 -->
            <li>
              <el-input v-model="g" oninput="value=value.replace(/^([0-9]\d*\.?\d{0,3})?.*$/,'$1')"
                onfocus="this.select()"></el-input>
            </li>
            <!-- 重量 -->
            <li>
              <el-input v-model="weight" oninput="value=value.replace(/^([0-9]\d*\.?\d{0,3})?.*$/,'$1')"
                onfocus="this.select()"></el-input>

            </li>
          </ul>

        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <el-button @click="dialogVisible = false">{{
          $t("message.cancel")
        }}</el-button>
        <!-- 保存 -->
        <el-button type="primary" @click="save">{{
          $t("message.ok")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>

import { attrOption } from "@/utlis/options";
import { mapState } from "vuex";
export default {
  data() {
    return {
      num: "",
      attr: "",
      c: "",
      k: "",
      g: "",
      weight: '',
      attrOption,
      dialogVisible: false,
      porder_sn: this.$route.query.porder_sn,
    };
  },
  computed: {
    ...mapState({
      boxIds: (state) => state.porderDetail.boxIds,
      boxList: (state) => state.porderDetail.boxList,
    }),
  },
  watch: {
    dialogVisible() {
      if (this.dialogVisible) {
        let itemData = null
        this.boxList.forEach((item) => {
          item.group.forEach((items) => {
            itemData = items.list.find(box => box.checked)
          });
        });
        if (itemData != null) {
          this.c = itemData.length
          this.k = itemData.width
          this.g = itemData.height
          this.weight = itemData.weight
          this.attr = `${this.c}*${this.k}*${this.g}`
        }
      }
    },
  },

  created() { },
  methods: {
    // 保存
    save() {
      let datas = {
        ids: this.boxIds,
        attr: this.attr,
        length: this.c,
        width: this.k,
        height: this.g,
      };
      if (this.attr == "") return this.$message.error("未选择箱型");
      if (this.c == "") return this.$message.error("请输入箱子的长");
      if (this.k == "") return this.$message.error("请输入箱子的宽");
      if (this.g == "") return this.$message.error("请输入箱子的高");
      this.$api.porderApi.modifyBoxAttr(datas).then((res) => {
        let datass = {
          ids: this.boxIds,
          weight: this.weight,
        };
        if (this.weight == "") return this.$message.error("请输入要修改的重量");
        this.$api.porderApi.modifyBoxWeight(datass).then((response) => {
          this.$message.success(response.msg);
          this.dialogVisible = false;
          this.$store.dispatch("freightList", { porder_sn: this.porder_sn });
          this.$store.commit("setBoxIds", []);
        });
      });
    },
    // 取到长宽高
    setCWK(e) {
      let arr = e.split("*");
      this.c = arr[0];
      this.k = arr[1];
      this.g = arr[2];
    },
  },
};
</script>
<style lang='scss' scoped>
.content {
  margin: 0px 15px;

  .table {
    border: 1px solid #edeff4;

    ol {
      display: flex;
    }

    ul {
      display: flex;
      padding: 0;
      border: 0;

      li {
        padding: 24px 0;
      }
    }

    li {
      border-right: 1px solid #edeff4;

      &:nth-last-child(1) {
        border: 0;
      }
    }

    .flex15 {
      flex: 1.5;
    }
  }

  /deep/.el-input {
    width: 60%;
  }

  /deep/.el-select {
    .el-input {
      width: 100%;
    }

    width: 80%;
  }
}
</style> 